import { render, staticRenderFns } from "./QuestionTooltip.vue?vue&type=template&id=8d79efb4&scoped=true&"
import script from "./QuestionTooltip.vue?vue&type=script&lang=js&"
export * from "./QuestionTooltip.vue?vue&type=script&lang=js&"
import style0 from "./QuestionTooltip.vue?vue&type=style&index=0&id=8d79efb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d79efb4",
  null
  
)

export default component.exports